<template>
    <div v-if="showInstructors">
        <img
            v-for="(instructor, index) in limitedInstructors"
            :key="index"
            :class="['thumbnail__instructor', getPositionClass(index)]"
            :srcset="`${getInstructorUrl(instructor).x1} 1x, ${getInstructorUrl(instructor).x2} 2x`"
            :src="getInstructorUrl(instructor).x1"
            alt="Instructor Image"
            v-if="limitedInstructors"
        />
        <div v-if="remainingInstructors > 0" :class="['thumbnail__instructor', 'thumbnail__remaining']">
            +{{ remainingInstructors }}
        </div>
    </div>
</template>
<script>
    export default {
        name: 'thumbnail-instructors',
        props: {
            course: {
                type: Object,
                required: true
            }
        },
        computed: {
            limitedInstructors () {
                if (!this.course.instructors) {
                    return ''
                }
                return this.course.instructors.slice(0, 3)
            },
            remainingInstructors () {
                if (!this.course.instructors) {
                    return ''
                }
                return this.course.instructors.length - 3
            },
            showInstructors () {
                return this.course.thumbnailOptions?.useInstructorImage
            }
        },
        methods: {
            getInstructorUrl (instructor) {
                if (instructor) {
                    return {
                        x1: instructor.avatarUrl.x1,
                        x2: instructor.avatarUrl.x2
                    }
                }
            },
            getPositionClass (index) {
                if (index < 3) {
                    return `position-${index + 1}`
                }
                return 'position-remaining'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .thumbnail {
        &__instructor {
            width: 60px;
            height: 60px;
            border-radius: 40px;
            position: absolute;
            bottom: 10px;
            border: 1px solid $silver_chalice;
            background-color: $concrete;

            [class*="mobile"] & {
                height: 40px;
                width: 42px;
            }

            &.position-1 {
                z-index: 100;
                left: 10px;
            }

            &.position-2 {
                z-index: 50;
                left: 55px;
            }
            &.position-3 {
                z-index: 40;
                left: 100px;
            }
        }

        &__remaining {
            z-index: 30;
            left: 145px;
            background-color: $bright_gray;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Nunito-Medium, sans-serif;
        }
    }
    @include totem_thumbnail_item_mosaic;
</style>
